import _ from 'lodash';
import { getMetadata } from '@/api/common/useRequest';
import { XMLParser } from 'fast-xml-parser';
/**
 * 获取指定Service的Entity信息
 * @param {string} serviceSchemaId Schema ID
 * @returns {array} Entity信息
 */
export async function getSchemaByServiceId(serviceSchemaId) {
  try {
    const resData = await getMetadata(`${serviceSchemaId}/$metadata?sap-documentation=all`);
    let ret = null;
    if (!_.isEmpty(resData)) {
      const parser = new XMLParser({
        attributeNamePrefix: '',
        attributesGroupName: '_attributes',
        ignoreAttributes: false,
        ignoreDeclaration: true
      });
      ret = parser.parse(resData);
      ret = _.get(ret, ['edmx:Edmx', 'edmx:DataServices', 'Schema']);
      // 因xml解析时，只有一个节点的场合，节点数据被转换为对象。此处为统一格式，将EntityType转换为数组。
      if (!_.isEmpty(ret.EntityType) && !Array.isArray(ret.EntityType)) {
        ret.EntityType = [ret.EntityType];
      }
    }
    return ret;
  } catch (err) {
    // alert(123)
    console.error(err);
    // throw new ApplicationError('SYCOM004E')
  }
}